// extracted by mini-css-extract-plugin
export default {"row":"style_row__9Qpmp","col__left":"style_col__left__Uh8a4","col__right":"style_col__right__1LuaG","img":"style_img__3PEOG"};